import { getErrorMetadataObject } from 'Helpers/ssrRetry';

export const initialState = {
    isFetching: false,
    isError: false,
    data: null,
    errorMetadata: {}
};

const navigationTreeAdapter = (options = [], childKey = 'children') =>
    options.reduce((acc, curr) => {
        let child = [];

        if (curr[childKey] && curr[childKey].length > 0) {
            child = navigationTreeAdapter(curr[childKey], childKey);
        }

        const findId = curr.searchAttributes.find(atr => atr.name === 'categoryId');

        if (child.length) {
            return [...acc, { id: findId.value, name: curr.name, categoryHint: curr.categoryHint, sub_categories: child }];
        }
        return [...acc, { id: findId.value, name: curr.name, categoryHint: curr.categoryHint }];
    }, []);

export default (state = initialState, action) => {
    switch (action.type) {
        case 'REQUEST_BXP_NAVIGATION_TREE':
            return {
                ...state,
                isFetching: true
            };
        case 'RECEIVE_BXP_NAVIGATION_TREE':
            return {
                isFetching: false,
                isError: false,
                data: navigationTreeAdapter(action.data.nodes)
            };
        case 'ERROR_BXP_NAVIGATION_TREE':
            return {
                isFetching: false,
                isError: true,
                data: null,
                errorMetadata: getErrorMetadataObject(action, state.errorMetadata)
            };
        default:
            return state;
    }
};
